// Настройки кабинета психолога и их значения по умолчанию. Служебное из первой версии (номера папок Google,
// коды календаря, порядок групп) живёт теперь в своих таблицах, а не в настройках.

export const MEET = { MEET: 'meet', ZOOM: 'zoom', OWN_LINK: 'own_link', NONE: 'none', OFFLINE: 'offline',
  BY_GROUP: 'by_group' } as const;
export type MeetKind = typeof MEET[keyof typeof MEET];
export const MEET_LABEL: Readonly<Record<MeetKind, string>> = {
  meet: 'новая Meet', zoom: 'новая Zoom', own_link: 'постоянная ссылка', none: 'без встречи', offline: 'очно',
  by_group: 'ссылку присылает проект',
};

export interface Settings {
  main_currency: string;        // в ней итоги и долги
  second_currency: string;      // показывается рядом как «≈»
  tz: string;                   // пояс психолога: расписание и календарь в нём
  step: number;                 // шаг времени начала при записи, мин
  meet_default: boolean;        // создавать Google Meet новым клиентам с онлайн-встречей
  meet_kind_default: MeetKind;
  addresses: string;            // адреса очных сессий через ;
  receipt_service: string;
  receipt_due_day: number;
  receipt_remind_hour: number;
  tax_person: number;
  tax_org: number;
  reminder_text: string;
  rule_hours: number;           // отмена «вовремя», если раньше, чем за столько часов
  rule_late: string;            // поздняя отмена: 0% · 50% · 100% или сумма
  rule_noshow: string;
  rule_psy: string;
  rule_auto: boolean;           // удалили встречу в календаре — «вовремя» или «поздно» по порогу
  type_break_default: number;
  first_month: string;
  sync_mode: 'both' | 'push' | 'pull';
  sync_unknown: 'create' | 'skip';
  sync_back: number;
  sync_ahead: number;
  cal_title_coded: boolean;     // писать встречи в её формате: «ИК Вероника тг 74»
  cal_reserve_mark: 'start' | 'end';
  cal_source: string;           // календарь, к встречам которого привязаны перенесённые сессии (из первой версии)
  links_checked: string;        // когда все связанные встречи сверены с клиентами их сессий (один раз); пусто — ещё нет
  sessions_back: number;        // сессии в приложении: за сколько дней назад; 0 — все
  user_name: string;
  theme: 'system' | 'light' | 'dark';
  tz_extra: string;
  color_personal: string;
  color_project: string;
  bg_light: string;
  bg_dark: string;
  grp_sort: string;
}

export const DEFAULT_SETTINGS: Readonly<Settings> = {
  main_currency: 'AMD', second_currency: 'EUR', tz: 'Asia/Yerevan', step: 5, meet_default: true,
  meet_kind_default: MEET.MEET,
  addresses: '', receipt_service: 'Психологическая консультация', receipt_due_day: 9, receipt_remind_hour: 20,
  tax_person: 4, tax_org: 6, reminder_text: '{имя}, напоминаю о нашей сессии {когда} ({пояс}). {ссылка}',
  rule_hours: 24, rule_late: '100%', rule_noshow: '100%', rule_psy: '0%', rule_auto: true, type_break_default: 15,
  first_month: '', sync_mode: 'both', sync_unknown: 'skip', sync_back: 7, sync_ahead: 120, cal_title_coded: false,
  cal_reserve_mark: 'start', cal_source: '', links_checked: '', sessions_back: 0, user_name: '', theme: 'system', tz_extra: '', color_personal: 'blue',
  color_project: 'violet', bg_light: '', bg_dark: '', grp_sort: 'name',
};

export const SETTING_KEYS = Object.keys(DEFAULT_SETTINGS) as ReadonlyArray<keyof Settings>;

// Настройки из базы поверх значений по умолчанию; незнакомые ключи и значения не того вида отбрасываются.
export function withDefaults(stored: Readonly<Record<string, unknown>>): Settings {
  const out: Record<string, unknown> = { ...DEFAULT_SETTINGS };
  for (const k of SETTING_KEYS) {
    const v = stored[k], def = DEFAULT_SETTINGS[k];
    if (v !== undefined && v !== null && typeof v === typeof def) out[k] = v;
  }
  return out as unknown as Settings;
}

// Типы сессий и график работы нового кабинета.
export const DEFAULT_TYPES: ReadonlyArray<{ name: string; dur: number; brk: number; isDefault: boolean }> = [
  { name: 'Стандартная', dur: 50, brk: 15, isDefault: true },
  { name: 'Короткая', dur: 30, brk: 15, isDefault: false },
  { name: 'Пара', dur: 90, brk: 30, isDefault: false },
];
export const DEFAULT_WEEK: ReadonlyArray<{ on: boolean; start: number; end: number; lunchStart: number | null;
  lunchEnd: number | null }> = [
  { on: true, start: 600, end: 1140, lunchStart: 780, lunchEnd: 840 },
  { on: true, start: 600, end: 1140, lunchStart: 780, lunchEnd: 840 },
  { on: true, start: 600, end: 1140, lunchStart: 780, lunchEnd: 840 },
  { on: true, start: 600, end: 1140, lunchStart: 780, lunchEnd: 840 },
  { on: true, start: 600, end: 1140, lunchStart: 780, lunchEnd: 840 },
  { on: true, start: 660, end: 900, lunchStart: null, lunchEnd: null },
  { on: false, start: 600, end: 1140, lunchStart: null, lunchEnd: null },
];
